import {Card} from '@jobseeker/lotus/components';
import {VersionVariants} from '@jobseeker/lotus/enums/variants';
import {AdListCategory} from './type';
import {Typography, useTheme} from '@mui/material';
import {cleanUrl} from '@jobseeker/lotus/utils';
import CourseList from '@jobseeker/lotus/components/JobList/V2';

const ListTrendingCourses = (props: {trendingCourses: AdListCategory[]}) => {
  const {trendingCourses} = props;

  const theme = useTheme();

  return (
    <Card
      variant={VersionVariants.VERSION_TWO}
      heading={
        <Typography
          fontSize={theme.typography.pxToRem(20)}
          fontWeight={500}
          ml={2}
          mb={2}
        >
          Trending Courses
        </Typography>
      }
      sx={{
        px: 0,
        py: 3,
        pb: 0,
        my: 2,
      }}
    >
      {trendingCourses?.map((course, index) => (
        <CourseList
          key={index}
          title={course.metadata[0].Title}
          variant={VersionVariants.VERSION_TWO}
          location={'Anywhere'}
          companyName={course.metadata[0].institute}
          experiance={`${course.metadata[0].minWorkExp || 0} - ${
            course.metadata[0].maxWorkExp || 30
          } Years`}
          date={Date.now()}
          refCode=""
          companyImgUrl={course.metadata[0]['Image Url']}
          showPosted={false}
          isCompanyJob={false}
          isPremiumJob={false}
          isSaved={false}
          showSaveIcon={false}
          redirectionLink={
            new URL(
              `/course/${cleanUrl(course.metadata[0].Title)}-${
                course.metadata[0].courseId
              }?refinv=scc&reforg=sc`,
              process.env.NEXT_PUBLIC_LOAD_CONFIG
            ).href
          }
        />
      ))}
    </Card>
  );
};

export default ListTrendingCourses;
